import React from 'react'
import { Typography } from 'antd'

interface FieldLabelProps {
  children: React.ReactNode
  size?: number
  mb?: number
}

// Small uppercase caption above form fields / list columns.
const FieldLabel: React.FC<FieldLabelProps> = ({ children, size = 10, mb }) => (
  <Typography.Text
    type="secondary"
    style={{ fontSize: size, textTransform: 'uppercase', display: 'block', marginBottom: mb }}
  >
    {children}
  </Typography.Text>
)

export default FieldLabel
